<template>
<div>
    <b-card>
        <b-card-body class="statistics-body">
            <job-report-list></job-report-list>
        </b-card-body>
    </b-card>
</div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
}
</script>
